const CATEGORY_COLORS = {
  Humanitarian: 'primary',
  Health: 'danger',
  Environmental: 'success',
  Education: 'warning',
}

export function categoryColor(category) {
  return CATEGORY_COLORS[category] ?? 'secondary'
}
